import React, { useEffect, useState } from 'react'
import Head from 'next/head'
import { useRouter } from 'next/router'
import Cookies from 'js-cookie'
import '@/styles/globals.scss'
import '@/styles/animate.scss'
import 'animate.css'
import Layout from '@/layouts/index'
import Script from 'next/script'
import { BROWSER } from '@/constant/env'
import GlobalContext, { IGlobalContext, initialGlobalContextValue } from '@/shared/context'
import 'antd/dist/antd.min.css'
import imageUtil from '@/utils/imageUtil'
import { suportWebp } from '@/utils'

suportWebp()

if (BROWSER) {
  //@ts-ignore
  // window.eruda && window.eruda.init()
  if (navigator.userAgent.match(/(Android)/) !== null) {
    document.body.classList.add('is-android')
  }
}

function MyApp({ Component, pageProps, ...restPageProps }: CustomNextAppProps) {
  const router = useRouter()
  const [globalContextValue, setGlobalContextValue] =
    useState<IGlobalContext>(initialGlobalContextValue)

  useEffect(() => {
    const supportsWebp = localStorage.getItem('supportsWebp') === 'support'
    if (!supportsWebp) {
      // 如果上面的suportWebp()已经执行完了，就不需要再判断一次，直接拿上面的结果
      if (window?.CLOUDCHECK?.isWebpAvailable !== undefined) {
        setGlobalContextValue({
          ...globalContextValue,
          supportsWebp: window?.CLOUDCHECK?.isWebpAvailable,
        })
        return
      }
      imageUtil.caniuseWebp((res: boolean) => {
        setGlobalContextValue({
          ...globalContextValue,
          supportsWebp: res,
        })
      }, 'lossy')
    }
  }, [])

  return (
    <>
      <Head>
        <title>【云背调】国内顶尖员工背景调查公司_入职背调就用云背调</title>
        {/* <meta name="referrer" content="no-referrer" /> */}
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no, viewport-fit=cover"
        />
        <meta
          name="description"
          content="云背调是国内知名的员工背景调查公司，致力于为企业提供专业、高效、合规的员工入职背景调查服务。员工简历核实，工作经历调查，工作表现访谈，胜任力评估，教育背景核实，金融违规核实，刑事犯罪记录，民事诉讼记录查询，信贷风险查询等。最快一个自然日交付背调报告，帮助企业有效规避招聘风险。云背调公司总部在上海，在上海、北京、深圳、香港设有分公司，目前已向超过10000家企业客户提供第三方背调服务，覆盖银行、保险、证券、互联网金融、大型互联网公司、地产公司、家政服务、制造业等多个行业。"
        />
        <meta
          name="keywords"
          content="高管背调,背景调查,背调,云背调,员工调查,入职背调,背调公司,员工背调公司,员工背景调查公司,入职背景调查,背调怎么做,背景调查公司,背调平台,第三方背调细致程度,背景调查如何进行,员工背景调查,背景调查怎么做,第三方背调,第三方背景调查,新员工背景调查,员工背景调查怎么做,背调网站,上海背调公司,杭州背调公司,北京背调公司,广州背调公司,深圳背调公司,员工犯罪记录,员工学历调查,高管履历背调,高管简历背调招聘风险管理"
        />
        <script src="//lf1-cdn-tos.bytegoofy.com/goofy/lark/op/h5-js-sdk-1.5.19.js" async></script>
      </Head>
      <div id="root">
        <GlobalContext.Provider
          value={{ state: globalContextValue, setState: setGlobalContextValue }}
        >
          <Layout>
            <GlobalContext.Consumer>
              {(context: IGlobalContext) => <Component router={router} globalContext={context} />}
            </GlobalContext.Consumer>
          </Layout>
        </GlobalContext.Provider>
      </div>
    </>
  )
}

// MyApp.getInitialProps = initialPropsFunc

export default MyApp
